<form [formGroup]="form" nz-form nzLayout="vertical">
  <div nz-row [nzGutter]="[20,20]">
    <!--  Tên Menu -->
    <extend-form-item nz-col nzMd="24" [errorDefs]="VALIDATORS.name" [errors]="f.name.errors" [showError]="isSubmitted"
                      labelText="Tên Menu" isRequired>
      <input nz-input formControlName="name" [maxLength]="200"/>
    </extend-form-item>
  </div>
  <div nz-row [nzGutter]="[20,20]">
    <!--  URL -->
    <extend-form-item nz-col nzMd="24" labelText="Đường dẫn">
      <input nz-input formControlName="url" [maxLength]="200"/>
    </extend-form-item>
  </div>

  <div nz-row [nzGutter]="[20,20]">
    <!--  Mã Menu -->
    <extend-form-item nz-col nzMd="12" [errorDefs]="VALIDATORS.menuCode" [errors]="f.menuCode.errors" [showError]="isSubmitted"
                      labelText="Mã Menu" isRequired>
      <app-input-group-icon (suffixClickEvent)="this.f.menuCode.enable()" suffixIcon="edit">
        <input nz-input formControlName="menuCode" [maxLength]="200"/>
      </app-input-group-icon>
    </extend-form-item>
    <!--  MENU CHA -->
    <extend-form-item nz-col nzMd="12" labelText="Chọn Menu Cha">
      <nz-tree-select
        #selectParentMenus
        style="width: 100%"
        [nzExpandedKeys]="expandKeys"
        [nzNodes]="_menus"
        nzShowSearch
        nzPlaceHolder="-- Chưa chọn menu cha --"
        formControlName="parentId"
      ></nz-tree-select>
    </extend-form-item>
  </div>


  <!--  Mô tả-->
  <extend-form-item labelText="Mô tả">
    <textarea nz-input formControlName="description" [maxLength]="200"></textarea>
  </extend-form-item>

  <div nz-row [nzGutter]="[20,20]">
    <extend-form-item
      nz-col
      nzMd="8"
      labelText="Trạng thái">
      <nz-switch style="padding-right: 4px" formControlName="enable"></nz-switch>
      <label>{{ f.enable.value ? 'Active' : 'InActive'}}</label>
    </extend-form-item>
    <extend-form-item
      nz-col
      nzMd="8"
      labelText="Độ ưu tiên">
      <nz-input-number class="w-100" nz-input formControlName="orderPriority" [nzMin]="0" [nzStep]="1">
      </nz-input-number>
    </extend-form-item>

    <extend-form-item
      nz-col
      nzMd="8"
      labelText="Icon">
      <nz-input-group [nzAddOnAfter]="suffixIcon">
        <input type="text" nz-input formControlName="icon"/>
      </nz-input-group>
      <ng-template #suffixIcon>
<!--        <i nz-icon [nzType]="f.icon.value" nz-theme="outline"></i>-->
        <i-tabler *ngIf="f.icon.value" [name]="f.icon.value" class="tb-icon tb-icon-m"></i-tabler>
      </ng-template>
    </extend-form-item>
  </div>


  <nz-divider></nz-divider>

  <div style="display: flex; column-gap: 1rem"
       [ngStyle]="(!data && mode === MODE.ADD) ? {'justify-content': 'end'} : ''">
    <button nz-button (click)="configMenu()" nzType="primary">
      <span nz-icon [nzType]="!data && mode === MODE.ADD ? 'plus' : 'save'"></span>
      {{ (!data && mode === MODE.ADD) ? 'Thêm mới' : 'Cập nhật' }}
    </button>

    <button nz-button (click)="cancel()">
      <span nz-icon nzType="close"></span>
      Hủy
    </button>
  </div>

</form>
